import { Component, Vue } from "vue-facing-decorator";
import { STORE_MUTATION } from "../enums/store_mutation";
import { __vueEvent } from "../constant";
import { EVENTS } from "../enums/events";
import { IConfig } from "../interfaces/config";
import { isMobile } from "../helpers/is_mobile";

@Component
export default class InfoPanel extends Vue {

    legalEntries = [];

    mounted() {
        this.listenEvents();
    }

    get isMobileActive() {
        return isMobile.any() || this.$store.state.isIFrameLoaded;
    }

    listenEvents() {
        __vueEvent.once(EVENTS.SetConfig, (config: IConfig) => {
            this.legalEntries = config.legalEntries;
        });
    }

    hideInfo() {
        this.$store.commit(STORE_MUTATION.SetShowInfoPanel, false);
    }
}
